'use client'

import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { type ComponentProps } from 'react'

import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

const { Root } = AccordionPrimitive

export const Item = ({
  className,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Item>) => {
  return (
    <AccordionPrimitive.Item
      className={cn('space-y-3', className)}
      {...props}
    />
  )
}

export const Trigger = ({
  className,
  children,
  strokeWidth = 1.5,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Trigger> & {
  strokeWidth?: number
}) => {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          'flex w-full cursor-pointer justify-between gap-4 transition-all',
          'ring-offset-background focus-visible:ring-ring rounded-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
          '[&[data-state=open]>svg]:rotate-180',
          className,
        )}
        {...props}
      >
        {children}
        <Icon name="arrow-bottom" size={24} strokeWidth={strokeWidth} />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

export const Content = ({
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Content>) => {
  return (
    <AccordionPrimitive.Content
      className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden"
      {...props}
    >
      {children}
    </AccordionPrimitive.Content>
  )
}

export { Root }
